import { action, flow, makeObservable, observable } from "mobx";
import { apiFetcher } from "../utils/fetch";

export default class Notification {
  constructor() {
    this.selected = {};

    makeObservable(this, {
      // Observable
      selected: observable,
      // Action
      // setSelected: action,

      // Flow
      send: flow,
    });
  }

  /**
   *
   * @param {Object} payload
   */
  *send(payload) {
    try {
      const { status, data } = yield apiFetcher().post("/notification/user/send", payload);
      return { status, data };
    } catch (error) {
      const status = error?.response?.status;
      const errorCode = error?.response?.data?.code;
      const errorMessage = error?.response?.data?.error || "Notification delivery service failed to send";
      return { status, errorCode, errorMessage };
    }
  }
}
